angular.module('blc').directive('googleplace', google_place_directive)
function google_place_directive() {
  return {
    //require: 'ngModel',
    scope: {
      place:   '=googleplace',
      country: '=',
      ngModel: '=',
      index:   '=?',
      details: '=?'
    },
    link: link
  }
  function link(scope, element, attrs, model) {
    scope.$watch('place', function(curr, prev) { if (curr!==prev) element.val(curr); });
    element.val(scope.place);
    var country;
    var index= scope.index || 0;
    var that = scope;
    var options = {
      types: [],
      componentRestrictions: {}
    };
    var quote = scope.$parent.quote;
    scope.gPlace = new google.maps.places.Autocomplete(element[0], options);

    element.on('input', reset_error  );
    element.on('blur',   update_scope );
    google.maps.event.addListener(scope.gPlace, 'place_changed', function() { element.blur(); });
    function update_scope() {
      reset_error();
      var geoComponents = scope.gPlace.getPlace();
      if (!geoComponents) {
        // seems empty
        scope.$apply(function() {
          scope.place = ''
        })
        return;
      }
      var addressComponents = geoComponents.address_components;
      addressComponents = addressComponents.filter(function(component){
        switch (component.types[0]) {
          case "locality": // city
            return true;
          case "administrative_area_level_1": // state
            return true;
          case "country": // country
            country = component.short_name;
            return true;
          default:
            return false;
        }
      }).map(function(obj) {
        return obj.long_name;
      });

      scope.$apply( function() {
        scope.details = addressComponents; // array containing each location component
        quote.geo[index] = geoComponents.geometry.location.toJSON();
        if (quote.country_valid(country)) {
          scope.country = country;
          scope.place = element.val();
        } else {
          scope.$emit('error', element);
          scope.place = '';
        }
      });
    }
    function reset_error() { 
      scope.$emit('error',  null); 
    } 
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/google-places-directive.js
 ** module id = 17
 ** module chunks = 0
 **/